// import React, { useEffect, useState } from 'react';
// import './home.css'; // Import your CSS file

// const Home = () => {
//   const [data, setData] = useState(null);

//   const fetchData = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/dashboard`, {
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const data = await response.json();
//       console.log('Fetched fee data:', data);
//       setData(data);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     }
//   };

//   // Fetch data when the component mounts
//   useEffect(() => {
//     fetchData();
//   }, []);

//   return (
//     <div className="contain">
//       <main className="main-content">
//         <h1 className="stats-header">Statistics</h1>
//         <section className="stats-container">
//           {/* Example of statistics section */}
//           <div className="stat-box">
//             <p className="stat-number">{data?.referralGiven ?? '-'}</p>
//             <p className="stat-field">Referral Given</p>
//           </div>
//           <div className="stat-box">
//             <p className="stat-number">{data?.referralReceived ?? '-'}</p>
//             <p className="stat-field">Referral Received</p>
//           </div>
//           <div className="stat-box">
//             <p className="stat-number">{data?.amountGiven ?? '-'}</p>
//             <p className="stat-field">Business Given</p>
//           </div>
//           <div className="stat-box">
//             <p className="stat-number">{data?.amountReceived ?? '-'}</p>
//             <p className="stat-field">Business Received</p>
//           </div>
//           <div className="stat-box">
//             <p className="stat-number">{data?.numMeeingAttenance ?? '-'}</p>
//             <p className="stat-field">No Of Meeting Attendance</p>
//           </div>
//         </section>
//       </main>
//     </div>
//   );
// };

// export default Home;

// Home.jsx
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './home.css';
import Plus from '../src/images/plus.svg';
import nakamu from '../src/images/nakamu.png';

const Home = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [userName, setUserName] = useState('Loading...');
  const [userOccupation, setUserOccupation] = useState('Fetching role...');
  const location = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState({
    referralGiven: 0,
    referralReceived: 0,
    amountGiven: 0,
    amountReceived: 0,
    numMeeingAttenance: 0,
    oneToOne: 0,
  });

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/my-profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const userData = await response.json();
        setUserName(`${userData.firstName} ${userData.lastName}`);
        setUserOccupation(userData.occupation || 'No Category');
      } catch (error) {
        console.error('Error fetching user profile:', error);
      }
    };

    fetchUserProfile();

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/dashboard`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      setData({
        referralGiven: result?.referralGiven ?? 0,
        referralReceived: result?.referralReceived ?? 0,
        amountGiven: result?.amountGiven ?? 0,
        amountReceived: result?.amountReceived ?? 0,
        numMeeingAttenance: result?.numMeeingAttenance ?? 0,
        oneToOne: result?.oneToOne ?? 0,
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="contain">
      <main className="main-content">
        <h1 className="stats-header">Dashboard</h1>

        {isMobile && (
          <>
            <div style={{ backgroundColor: '#2865aa', width: '100vw', height: '14vw', position: 'fixed', top: '15vw', left: 0 }} />
            <div className="profile-card" style={{ height: '26vw', top: '16vw' }}>
              <img src={nakamu} alt="Profile Logo" className="profile-img" />
              <div className="profile-text">
                <h1>{userName}</h1>
                <h3>{userOccupation}</h3>
              </div>
            </div>
          </>
        )}

        <section className="stats-container">
          <div className="stats-row">
            <div className="stat-box">

              <p className="stat-number">{data?.amountReceived ?? '-'}</p>
              {/* <p className="stat-number">15,45,45,54,222</p> */}
              <p className="stat-field">Business Given</p>
            </div>
            <div className="stat-box">
              <img src={Plus} alt="plus icon" className="plus-icon" onClick={() => navigate('/AddReferral')} />
              <p className="stat-number">{data.referralGiven}</p>
              <p className="stat-field">Referral Given</p>
            </div>
            <div className="stat-box">
              <img src={Plus} alt="plus icon" className="plus-icon" onClick={() => navigate('/OneToOneAdd')} />
              <p className="stat-number">{data.oneToOne}</p>
              <p className="stat-field">One-to-One</p>
            </div>
          </div>

          <div className="stats-row">
            <div className="stat-box">
              <img src={Plus} alt="plus icon" className="plus-icon" onClick={() => navigate('/ThankYouAdd')} />
              <p className="stat-number">{data.amountGiven}</p>
              <p className="stat-field">Business Received</p>
            </div>
            <div className="stat-box">
              <p className="stat-number">{data.referralReceived}</p>
              <p className="stat-field">Referral Received</p>
            </div>
            <div className="stat-box">
              <p className="stat-number">{data.numMeeingAttenance}</p>
              <p className="stat-field">No Of Meeting Attendance</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;
